import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=3a8f0ef4"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"
import style0 from "./FormData.vue?vue&type=style&index=0&id=3a8f0ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports